import { render, staticRenderFns } from "./StreamChart.vue?vue&type=template&id=8fd13de4&scoped=true"
import script from "./StreamChart.vue?vue&type=script&lang=ts"
export * from "./StreamChart.vue?vue&type=script&lang=ts"
import style0 from "./StreamChart.vue?vue&type=style&index=0&id=8fd13de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd13de4",
  null
  
)

export default component.exports